// ------------------------- ROTTERDAMMERS MAP ---------------------------------
export const netwerkInitMap = (loca) => {
  // if there is nothing passed in, then we will define default one
  if (!loca) {
    var loca = []; // Define the array outside the forEach loop
    const netwerkInfoDivs = document.querySelectorAll(".netwerk-info");

    netwerkInfoDivs.forEach(function (div) {
      const { lat, lng, name, body, address, url, tagswijk, tagsthema, colour, themagratis } =
        networkDataAttributeBuilder(div);

      // Assuming tagswijk and tagsthema are arrays
      var tagsWijkArray = Array.isArray(tagswijk) ? tagswijk : [tagswijk];
      var tagsThemaArray = Array.isArray(tagsthema) ? tagsthema : [tagsthema];

      loca.push({
        lat: lat,
        lng: lng,
        name: name,
        body: body,
        address: address,
        url: url,
        tagswijk: tagsWijkArray,
        tagsthema: tagsThemaArray,
        colour: colour,
        themagratis: themagratis,
      });
    });
  }


  var location = loca;
  // var rotterdam = { lat: 51.9225, lng: 4.47917 };
  var rotterdam = { lat: 51.9179868624474, lng: 4.473175209631193 };
  var mapOptions = {
    center: rotterdam,
    zoom: 10,
    draggable: true,
    scrollwheel: false,
    mapTypeControl: false,
    zoomControl: true,
    streetViewControl: false,
    styles: [
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "all",
        elementType: "geometry",
        stylers: [
          { saturation: 0 }, // Adjust saturation (values from -100 to 100)
          { lightness: 15 },   // Adjust lightness (values from -100 to 100)
          { visibility: "off" }, // Turn off all map features
        ],
      },
      {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [
          { visibility: "on" }, // Turn on landscape features
          { color: "#EAEAEA" }, // Set landscape color to white
        ],
      },
      {
        featureType: "road",
        elementType: "geometry",
        stylers: [
          { visibility: "on" }, // Turn on road features
          { color: "#F5F5F5" }, // Set road color to white
        ],
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [
          { visibility: "on" }, // Turn on water features
          { color: "#D6DBDB" }, // Set water color to white
        ],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
    ],
  };

  var netwerkMapElement = document.getElementById("netwerk-map-canvas");
  var homeNetowrkMapElement = document.getElementById("home-map-canvas");

  //detect if it is home page or network page and append to that
  const mapElement = homeNetowrkMapElement ? homeNetowrkMapElement : netwerkMapElement;

  if (mapElement) {
    var map = new google.maps.Map(mapElement, mapOptions);
    var mapDiv = mapElement.querySelector("div");
    if (mapDiv) {
      mapDiv.id = "netwerkMap";
      var tilesloadedListener = google.maps.event.addListener(
        map,
        "tilesloaded",
        function () {
          var iframe = mapDiv.querySelector("iframe");
          if (iframe) {
            iframe.title = "kaart met partners";
            google.maps.event.removeListener(tilesloadedListener); // Remove the listener to prevent memory leaks
          }
        }
      );
    }

    var bounds = new google.maps.LatLngBounds();

    var currentSelectedMarker = null;
    var initialFillColor = "#175EC7";
    var initialTextColor = "black";
    var markerArray = [];

    function getMarkerIcon(fillColor, textColor) {
      //   var svgCodeWithColor = `
      //   <svg xmlns="http://www.w3.org/2000/svg" width="22" height="28" viewBox="0 0 22 28" fill="none">
      //     <path d="M11 0C8.08363 0.00330842 5.28766 1.1633 3.22548 3.22548C1.1633 5.28766 0.00330842 8.08363 0 11C0 20.4125 10 27.5212 10.4263 27.8188C10.5944 27.9365 10.7947 27.9997 11 27.9997C11.2053 27.9997 11.4056 27.9365 11.5737 27.8188C12 27.5212 22 20.4125 22 11C21.9967 8.08363 20.8367 5.28766 18.7745 3.22548C16.7123 1.1633 13.9164 0.00330842 11 0ZM11 7C11.7911 7 12.5645 7.2346 13.2223 7.67412C13.8801 8.11365 14.3928 8.73836 14.6955 9.46927C14.9983 10.2002 15.0775 11.0044 14.9231 11.7804C14.7688 12.5563 14.3878 13.269 13.8284 13.8284C13.269 14.3878 12.5563 14.7688 11.7804 14.9231C11.0044 15.0775 10.2002 14.9983 9.46927 14.6955C8.73836 14.3928 8.11365 13.8801 7.67412 13.2223C7.2346 12.5645 7 11.7911 7 11C7 9.93913 7.42143 8.92172 8.17157 8.17157C8.92172 7.42143 9.93913 7 11 7Z" fill="${fillColor}"/>
      //   </svg>
      // `;
      var svgCodeWithColor = `
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="28" viewBox="0 0 22 28" fill="none">
          <path d="M11 0C8.08363 0.00330842 5.28766 1.1633 3.22548 3.22548C1.1633 5.28766 0.00330842 8.08363 0 11C0 20.4125 10 27.5212 10.4263 27.8188C10.5944 27.9365 10.7947 27.9997 11 27.9997C11.2053 27.9997 11.4056 27.9365 11.5737 27.8188C12 27.5212 22 20.4125 22 11C21.9967 8.08363 20.8367 5.28766 18.7745 3.22548C16.7123 1.1633 13.9164 0.00330842 11 0ZM11 7C11.7911 7 12.5645 7.2346 13.2223 7.67412C13.8801 8.11365 14.3928 8.73836 14.6955 9.46927C14.9983 10.2002 15.0775 11.0044 14.9231 11.7804C14.7688 12.5563 14.3878 13.269 13.8284 13.8284C13.269 14.3878 12.5563 14.7688 11.7804 14.9231C11.0044 15.0775 10.2002 14.9983 9.46927 14.6955C8.73836 14.3928 8.11365 13.8801 7.67412 13.2223C7.2346 12.5645 7 11.7911 7 11C7 9.93913 7.42143 8.92172 8.17157 8.17157C8.92172 7.42143 9.93913 7 11 7Z" fill="${fillColor}"/>
          <circle cx="11" cy="11" r="4" fill="white"/>
        </svg>`;


      return {
        url: "data:image/svg+xml;charset=UTF-8;base64," + btoa(svgCodeWithColor),
      };
    }

    var tagsArray = "";
    var locationsLength = location.length;
    // console.log("Number of locations: " + locationsLength);
    location.forEach(function (location) {

      var circleFillColor = location.colour;
      var textColor = initialTextColor;

      var markerIcon = getMarkerIcon(circleFillColor, textColor);

      var marker = new google.maps.Marker({
        position: location,
        map: map,
        // title: "Hello World!",
        icon: markerIcon,
      });

      markerArray.push(marker);

      bounds.extend(location); // Extend the bounds with each location

      currentSelectedMarker = markerArray[0];
      const modal = document.querySelector('.marker-modal');
      const closeModalButton = document.getElementById('closeModalButton');
      const modalName = document.getElementById('modal-name');
      const modalBody = document.getElementById('modal-body');
      const modalAddress = document.getElementById('modal-address');
      const modalWebsiteButton = document.getElementById('modal-website-button');
      const modalGratis = document.getElementById('gratis-label');

      marker.addListener("click", function () {

        // console.log("click it", location);
        // Set content and styles
        modalName.innerHTML = location.name;
        modalBody.innerHTML = location.body;
        modalAddress.innerHTML = location.address;
        modal.style.backgroundColor = location.colour;
        modalWebsiteButton.setAttribute('href', location.url);
        modalWebsiteButton.style.color = location.colour;

        if (location.gratis === "1") {
          modalGratis.classList.remove('hidden');
        } else {
          modalGratis.classList.add('hidden');
        }

        modal.classList.toggle('hidden');

        closeModalButton.addEventListener('click', function () {
          modal.classList.add('hidden');
        });

        modalWebsiteButton.onclick = function () {
          window.open(location.url, '_blank');
        };
      });

    });

    // Fit the map to the bounds
    // Create a LatLngBounds object for Rotterdam
    var rotterdamBounds = new google.maps.LatLngBounds(
      // new google.maps.LatLng(51.9017144, 4.4312005), // Southwest coordinates
      // new google.maps.LatLng(51.9240349, 4.4898371)  // Northeast coordinates
      // new google.maps.LatLng(51.8429, 4.2667),
      // new google.maps.LatLng(51.9929, 4.6167)
      new google.maps.LatLng(51.899, 4.428),
      new google.maps.LatLng(51.926, 4.492)

    );

    // map.fitBounds(rotterdamBounds);

    // Apply the bounds to the map
    // map.fitBounds(bounds);

    const noLocationModal = document.querySelector('.noloca-modal');
    if (locationsLength == 0) {
      map.fitBounds(rotterdamBounds);
      noLocationModal.classList.remove('hidden');
    }
    else {
      map.fitBounds(bounds);
      if (!noLocationModal.classList.contains('hidden')) {
        noLocationModal.classList.add('hidden');
      }

    }

  }

};

export const networkDataAttributeBuilder = (div) => {
  const newData = {};
  newData.lat = parseFloat(div.getAttribute("data-lat"));
  newData.lng = parseFloat(div.getAttribute("data-lng"));
  newData.name = div.getAttribute("data-name");
  newData.body = div.getAttribute("data-body");
  newData.address = div.getAttribute("data-address");
  newData.url = div.getAttribute("data-url");
  newData.colour = div.getAttribute("data-colour");
  newData.tags = "";
  if (div.getAttribute(" data-tagswijk") != "") {
    newData.tags = JSON.parse(div.getAttribute(" data-tagswijk"));
  }
  if (div.getAttribute(" data-tagsthema") != "") {
    newData.tags = JSON.parse(div.getAttribute(" data-tagsthema"));
  }
  newData.gratis = div.getAttribute("data-themagratis");
  return newData;
};
